import { render } from "./TabBtn.vue?vue&type=template&id=0cb18f10&scoped=true"
import script from "./TabBtn.vue?vue&type=script&lang=js"
export * from "./TabBtn.vue?vue&type=script&lang=js"

import "./TabBtn.vue?vue&type=style&index=0&id=0cb18f10&lang=less&scoped=true"

import exportComponent from "/builds/ChinaApplicationPool/dia/smart-search/mobile-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cb18f10"]])

export default __exports__